import { useTranslation } from 'react-i18next'

import { ScrollableTabs } from '@reveni-io/reveni-ui'

import { brandingTabs } from '../constants'
import TabLabel from '../TabLabel/TabLabel'
import * as Styles from './styles'

const BrandingTabs = ({ activeTab, onChangeTab, tabErrors = {} }) => {
  const { t } = useTranslation()

  const tabs = [
    {
      label: <TabLabel label={t('Marca e imágenes')} hasError={tabErrors[brandingTabs.brandAndImages]} />,
      value: brandingTabs.brandAndImages,
    },
    {
      label: <TabLabel label={t('Botones y enlaces')} hasError={tabErrors[brandingTabs.buttonsAndLinks]} />,
      value: brandingTabs.buttonsAndLinks,
    },
    {
      label: <TabLabel label={t('Selectores')} hasError={tabErrors[brandingTabs.selectors]} />,
      value: brandingTabs.selectors,
    },
  ]

  return (
    <Styles.Container>
      <ScrollableTabs tabs={tabs} value={activeTab} onChange={onChangeTab} />
    </Styles.Container>
  )
}

export default BrandingTabs
